import styled from '@emotion/styled';

export const StyledHistoryDetailInfo = styled.div`
  font-size: 16px;

  ul {
    display: flex;
    align-items: center;

    li {
      &:first-of-type {
        padding-right: 20px;
      }

      &:nth-of-type(2) {
        padding-left: 20px;
        padding-right: 20px;
      }

      &:nth-of-type(3) {
        padding-left: 20px;
      }

      & + li {
        border-left: 1px solid #e0e0e0;
      }

      strong {
        margin-right: 8px;
      }
    }
  }
`;
